<template>
  <div class="sirius_xm-container" v-show="isSiriusXmInfoRetrieved">
    <div class="vehicle-of-interest">
      <div class="title">{{ $t('message.spotlight.sxm.footer.vehicleOfInterest') }}</div>
      <div class="vehicle-info" :title="vehicleString">{{ vehicleString }}</div>
    </div>
    <div class="sirius_xm-details">
      <img src="@/assets/sxm-logo-blue.svg" />
      <div class="trial-duration">{{ siriusXmStatusMessage }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import vehicleService from '@/services/vehicleService';
import log from '@/services/log';

export default {
  name: 'SiriusXMBanner',
  data() {
    return {
      freeTrialMessage: '',
      hasTrial: false,
      siriusXmInfo: {},
    };
  },
  computed: {
    ...mapGetters('business', ['isSiriusXmInfoRetrieved']),
    ...mapGetters('vehicle', ['vehicleString']),
    ...mapState('vehicle', ['vehicleInfo']),
    siriusXmIsFreeTrial() {
      return this.hasTrial;
    },
    siriusXmStatusMessage() {
      return this.siriusXmIsFreeTrial ? this.freeTrialMessage : this.$t('message.spotlight.sxm.footer.enabled');
    },
  },
  async mounted() {
    await this.getSiriusXmInformation();
    await this.logElementRendered();
  },
  methods: {
    async getSiriusXmInformation() {
      const { vin, make, status } = this.vehicleInfo;
      // eslint-disable-next-line camelcase
      const { key, external_id, language } = this.$route.query;
      try {
        const result = await vehicleService.siriusXmBannerInfo(vin, key, external_id, language, make, status);
        this.hasTrial = result.data.hasTrial;
        this.freeTrialMessage = result.data.trial_message;
        this.siriusXmInfo = result.data;
        this.$store.commit('business/SET_SIRIUS_XM_INFO', result.data);
      } catch (error) {
        this.$store.commit('business/SET_SIRIUS_XM_INFO', {});
      }
    },
    async logElementRendered() {
      if (!this.isSiriusXmInfoRetrieved) {
        return;
      }

      try {
        const payload = {
          elementRendered: 'siriusXM_footer',
        };
        await this.$store.dispatch('metrics/logModalElementRendered', payload);
      } catch (error) {
        log('Error in logging element rendered', error);
      }
    },
    async logOnRouteChange(toRoute, fromRoute) {
      if (toRoute !== fromRoute) {
        await this.logElementRendered();
      }
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.path': async function (toRoute, fromRoute) {
      await this.logOnRouteChange(toRoute, fromRoute);
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables/breakpoints';

.sirius_xm-container {
  display: flex;
  justify-content: space-between;
  padding: 5px 5%;
  background-color: rgb(240, 244, 247);
  border: 1px solid rgb(218, 226, 234);
  max-height: 55px;
  bottom: 0;
  position: fixed;
  width: 100%;
  z-index: 1030;
}

.vehicle-of-interest {
  text-align: left;
  width: fit-content;
  max-width: 57%;

  .title {
    font-size: 12px;
  }
  .vehicle-info {
    font-size: 16px;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.sirius_xm-details {
  display: inline-flex;
  align-items: center;
  justify-content: space-evenly;

  img {
    min-width: 76px;
    max-width: 86px;
    margin-right: 10px;
  }

  .trial-duration {
    font-size: 12px;
    color: rgb(75, 88, 99);
    text-transform: capitalize;
    text-align: center;
  }
}

/* Mobile only*/
@media only screen and (max-width: $breakpoint-mobile) {
  .sirius_xm-details {
    flex-direction: column;

    img {
      margin-right: 0;
    }
  }
}
</style>
